import { render } from "./IconInline.vue?vue&type=template&id=0a675384&ts=true"
import script from "./IconInline.vue?vue&type=script&lang=ts"
export * from "./IconInline.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\berge\\Desktop\\My Projects\\o2p-shop-planner\\SP.App\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__